import './Checkbox-2aef6693.css';

var classes = {"Checkbox":"prc-Checkbox-Checkbox-gIwWX","checkmarkOut":"prc-Checkbox-checkmarkOut-mlBVw","checkmarkIn":"prc-Checkbox-checkmarkIn-S5zG9"};

export { classes as default };
